import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

import Enumerable from "linq";
import { Style, UsageType } from "../../common/enums/DRCXEnums";
import { DRCXAvailableOptionalColumn } from "../../common/models/drcx/DRCXAvailableOptionalColumn";
import { IDRCXAvailableOptionalColumnDTO } from "../../common/models/drcx/DRCXAvailableOptionalColumnDTO";
import { IPageConfigurationAvailableOptionalColumn } from "./Models";

export function mapToAvailableOptionalColumnLookup(objectType: eLynxObjectTypeEnum, pageConfigurationOptionalColumns: IPageConfigurationAvailableOptionalColumn[]): 
        Enumerable.ILookup<string, DRCXAvailableOptionalColumn> | undefined  {

    const shapedDTOs = pageConfigurationOptionalColumns.map(o => {
        return {

            ds: Style.Pivot_Object_Only,
            ot: objectType,
            dt: o.displayName,
            ky: o.displayName,
            oc: o.optionalColumn,
            ut: o.required ? UsageType.Required : o.default ? UsageType.Default : undefined,
            id: o.id 
        } as IDRCXAvailableOptionalColumnDTO
    });

    return shapedDTOs ? Enumerable.from(shapedDTOs).toLookup(
        d => DRCXAvailableOptionalColumn.getLookupKey(d.ds ?? Style.Linear, d.ot ?? eLynxObjectTypeEnum.None),
        // Note: Setting key = d.dt instead of d.ky is intentional. This enables custom labels to work.
        d => new DRCXAvailableOptionalColumn(d.dt, d.oc, d.dt, d.ut, d.do, undefined, d.id)) :
        undefined;
}
